var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('colgroup',{class:"v-table-wrapper-colgroup"},_vm._l((_vm.scope.props.headers),function(column,index){return _c('col',{key:index,class:("v-table-wrapper-col-" + index),attrs:{"width":_vm.cols[index]}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }